export const isEmailIdValid = (emailId: string) => {
    const emailIdValidationRegex = /^[\w-\.\+]+@([\w-]+\.)+[\w-]{2,8}$/g;

    return Boolean(emailId?.match(emailIdValidationRegex));
};
